import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthServiceService } from '../shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import { LocalServiceService } from '../shareModule/services/local-service.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-edit-types',
  templateUrl: './edit-types.component.html',
  styleUrl: './edit-types.component.scss',
})
export class EditTypesComponent implements OnChanges {
  @Input()
  typeOneNaming = '';

  @Input()
  typeTwoNaming = '';

  @Input()
  newTypeGroup = '';

  @Input()
  newType = '';

  @Input()
  currentProductCategoryAvailableTypes = [];

  @Input()
  selectedTypeToEdit = null;

  @Input({ required: true })
  categoryId;

  @Input()
  nameOfCurrentCategory = '';

  public subTypesOfSelectedType = [];

  public newSubType = '';

  public typeGroupingCustomNamesMap = new Map<number, string>();

  public typeImageBase64: string | ArrayBuffer | null = null;
  public selectedTypeImageFile: File | null = null;
  public imgUrl = environment.ImageUrl;
  public newTypeImageFile: File | null = null;
  public newTypeImagePreview: string | ArrayBuffer | null = null;
  public editingTypeId: number | null = null;
  public isEditMode = false;

  constructor(
    private modal: NgbActiveModal,
    private auth: AuthServiceService,
    private cdr: ChangeDetectorRef,
    private toastr: ToastrService,
    private local: LocalServiceService,
  ) {}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['categoryId']) {
      this.fetchTypesData();
    }
  }
  public closeCurrentOpenModal() {
    this.modal?.close();
  }

  public removeTypeFromAfterConfirmation(event, type) {
    event.stopPropagation();
    this.local
      .confirmYesNo({
        title: 'Are you sure you want to remove type',
        text: 'Are you sure you want to remove type',
        icon: 'warning',
      })
      .then((res) => {
        if (res.isConfirmed) {
          this.auth.deleteSubCategoryType(type.id).subscribe({
            next: () => {
              this.fetchTypesData();
              this.toastr.success('Type removed from product');
            },
            error: (err) => {
              console.error(err);
              this.toastr.error('Something went wrong while removing type');
            },
          });
        }
      });
  }

  public selectTypeToEdit(type) {
    this.selectedTypeToEdit = type;
    this.typeImageBase64 = null;
    this.selectedTypeImageFile = null;
    this._fetchSubTypeOfCurrentlySelectedType();
    
    // Populate form for editing
    this.isEditMode = true;
    this.editingTypeId = type.id;
    this.newType = type.name;
    this.newTypeGroup = type.type;
    this.newTypeImageFile = null;
    this.newTypeImagePreview = type.image ? (this.imgUrl + type.image) : null;
    this.cdr.detectChanges();
  }

  public cancelEdit() {
    this.isEditMode = false;
    this.editingTypeId = null;
    this.newType = '';
    this.newTypeGroup = '';
    this.newTypeImageFile = null;
    this.newTypeImagePreview = null;
    this.cdr.detectChanges();
  }
  private _fetchSubTypeOfCurrentlySelectedType() {
    this.auth.getSubTypesOfType(this.selectedTypeToEdit?.id).subscribe({
      next: (data: any) => {
        this.subTypesOfSelectedType = data.data;
      },
      error: console.error,
    });
  }
  public saveCategoryInfo() {
    this.auth
      .updateMemberCategoryInfo({
        name: this.nameOfCurrentCategory,
        id: this.categoryId,
      })
      .subscribe({
        next: () => {
          this.toastr.info(`Category name updated`);
        },
        error: (err) => {
          console.error(err);
          this.toastr.error(
            `Error while chaning categrory name to ${this.nameOfCurrentCategory}`,
          );
        },
      });

    const vals = [
      [
        1,
        this.typeOneNaming,
        this.typeOneNaming != this.typeGroupingCustomNamesMap[1],
      ],
      [
        2,
        this.typeTwoNaming,
        this.typeTwoNaming != this.typeGroupingCustomNamesMap[2],
      ],
    ];
    for (const [number, naming, cond] of vals) {
      if (cond) {
        this.auth
          .setTypeGroupingName(number, naming, this.categoryId)
          .subscribe({
            next: () => {
              this.toastr.info(`group ${number}'s name changed to ${naming}`);
            },
            error: (err) => {
              console.error(err);
              this.toastr.error(
                `Error while chaning group ${number}'s name changed to ${naming}`,
              );
            },
          });
      }
    }
  }

  public addNewType() {
    if (this.newTypeImageFile && !this.newTypeImageFile.type.startsWith('image/')) {
      this.toastr.error('Please select a valid image file for the type');
      return;
    }

    // Check if we're in edit mode
    if (this.isEditMode && this.editingTypeId) {
      // Update existing type
      // Pass undefined if no new image file to preserve existing image
      const imageToUpdate = this.newTypeImageFile || undefined;
      this.auth
        .updateSubCategoryType(
          this.editingTypeId,
          this.newType,
          this.newTypeGroup,
          imageToUpdate,
        )
        .subscribe({
          next: () => {
            this.toastr.success('Type updated successfully!');
            this.newType = '';
            this.clearNewTypeImage();
            this.isEditMode = false;
            this.editingTypeId = null;
            this.fetchTypesData();
          },
          error: (err) => {
            console.error(err);
            this.toastr.error('Something went wrong while updating the type');
          },
        });
    } else {
      // Create new type
      this.auth
        .createSubCategoryType(
          this.newType,
          this.newTypeGroup,
          this.categoryId,
          this.newTypeImageFile,
        )
        .subscribe({
          next: () => {
            this.toastr.success('Added!');
            this.newType = '';
            this.clearNewTypeImage();
            this.fetchTypesData();
          },
          error: (err) => {
            console.error(err);
            this.toastr.error('Something went wrong while adding a type');
          },
        });
    }
  }

  public addNewSubType() {
    if (!this.newSubType || !this.selectedTypeToEdit) {
      this.toastr.warning('Please enter a sub type name');
      return;
    }
    this.auth.createSubType(this.newSubType, this.selectedTypeToEdit?.id).subscribe({
      next: () => {
        this.toastr.success('Sub type added!');
        this.newSubType = '';
        this._fetchSubTypeOfCurrentlySelectedType();
      },
      error: (err) => {
        console.error(err);
        this.toastr.error('Something went wrong while adding a sub type');
      },
    });
  }

  public removeSubTypeFromAfterConfirmation(event, subType) {
    event.stopPropagation();
    this.local
      .confirmYesNo({
        title: 'Are you sure you want to remove sub type',
        text: 'Are you sure you want to remove sub type',
        icon: 'warning',
      })
      .then((res) => {
        if (res.isConfirmed) {
          this.auth.deleteSubType(subType.id).subscribe({
            next: () => {
              this._fetchSubTypeOfCurrentlySelectedType();
              this.toastr.success('Sub type removed');
            },
            error: (err) => {
              console.error(err);
              this.toastr.error('Something went wrong while removing sub type');
            },
          });
        }
      });
  }

  private setGroupingNames() {
    this.typeOneNaming = this.typeGroupingCustomNamesMap[1] ?? 'Categories';
    this.typeTwoNaming = this.typeGroupingCustomNamesMap[2] ?? 'Services';
  }

  public fetchTypesData() {
    if (this.categoryId && this.categoryId != -1) {
      this.auth.getTypesOfCategory(this.categoryId).subscribe({
        next: (data: any) => {
          this.currentProductCategoryAvailableTypes = data.data;

          this.cdr.detectChanges();
          //console.log('here 1', this.currentProductCategoryAvailableTypes)
        },
      });
      this.auth.getTypeGroupingNamesOfSubCategory(this.categoryId).subscribe({
        next: (data: any) => {
          for (const entry of data.data) {
            this.typeGroupingCustomNamesMap[entry.typeNumber] = entry.typeName;
          }
          this.nameOfCurrentCategory = data.nameOfCategory;
          this.setGroupingNames();
          //console.log('here 3', this.currentProductCategoryAvailableTypes)
        },
        error: console.error,
      });
    }
  }

  public onTypeImageSelected(event: any): void {
    const file = event.target.files[0];
    if (!file) return;

    // Validate file type
    if (!['image/png', 'image/jpg', 'image/jpeg'].includes(file.type)) {
      this.toastr.error('Please select a valid image file (PNG, JPG, JPEG)');
      return;
    }

    this.selectedTypeImageFile = file;

    const fileReader = new FileReader();
    fileReader.onload = () => {
      this.typeImageBase64 = fileReader.result;
      this.cdr.detectChanges();
    };
    fileReader.readAsDataURL(file);
  }

  public uploadTypeImage(): void {
    if (!this.selectedTypeImageFile || !this.selectedTypeToEdit) {
      this.toastr.warning('Please select an image first');
      return;
    }

    this.auth
      .setCategoryVariableBanner('TYPE', this.selectedTypeToEdit.id, this.selectedTypeImageFile)
      .subscribe({
        next: () => {
          this.toastr.success('Type image uploaded successfully');
          this.selectedTypeImageFile = null;
          // Refresh types data to get updated image
          this.fetchTypesData();
          // Update the selected type to show new image
          const updatedType = this.currentProductCategoryAvailableTypes.find(
            (t: any) => t.id === this.selectedTypeToEdit.id
          );
          if (updatedType) {
            this.selectedTypeToEdit = updatedType;
          }
        },
        error: (err) => {
          console.error(err);
          this.toastr.error('Something went wrong while uploading the image');
        },
      });
  }

  public removeTypeImage(): void {
    if (!this.selectedTypeToEdit) return;

    this.local
      .confirmYesNo({
        title: 'Remove Type Image',
        text: 'Are you sure you want to remove this image?',
        icon: 'warning',
      })
      .then((res) => {
        if (res.isConfirmed) {
          this.auth
            .setCategoryVariableBanner('TYPE', this.selectedTypeToEdit.id, null)
            .subscribe({
              next: () => {
                this.toastr.success('Type image removed successfully');
                this.typeImageBase64 = null;
                this.selectedTypeImageFile = null;
                // Refresh types data
                this.fetchTypesData();
                // Update the selected type
                const updatedType = this.currentProductCategoryAvailableTypes.find(
                  (t: any) => t.id === this.selectedTypeToEdit.id
                );
                if (updatedType) {
                  this.selectedTypeToEdit = updatedType;
                }
              },
              error: (err) => {
                console.error(err);
                this.toastr.error('Something went wrong while removing the image');
              },
            });
        }
      });
  }

  public onNewTypeImageSelected(event: any): void {
    const file = event.target.files?.[0];
    if (!file) {
      return;
    }
    if (!file.type.startsWith('image/')) {
      this.toastr.error('Please select a valid image file');
      return;
    }
    this.newTypeImageFile = file;
    const reader = new FileReader();
    reader.onload = () => {
      this.newTypeImagePreview = reader.result;
      this.cdr.detectChanges();
    };
    reader.readAsDataURL(file);
  }

  public clearNewTypeImage(): void {
    this.newTypeImageFile = null;
    this.newTypeImagePreview = null;
  }
}
